export function digitsOnly(value, maxLength) {
  const digits = String(value || "").replace(/\D/g, "");
  return maxLength ? digits.slice(0, maxLength) : digits;
}

export function decimalOnly(value, maxDecimals = null) {
  const raw = String(value || "").replace(/[^\d.]/g, "");
  const [whole = "", ...decimalParts] = raw.split(".");
  if (decimalParts.length === 0) return whole;
  const decimal = decimalParts.join("");
  const limitedDecimal = maxDecimals == null ? decimal : decimal.slice(0, maxDecimals);
  return `${whole}.${limitedDecimal}`;
}

export function integerOnly(value) {
  return digitsOnly(value);
}

export const phoneInputProps = {
  type: "text",
  inputMode: "numeric",
  pattern: "[0-9]{10}",
  maxLength: 10,
};

export const pincodeInputProps = {
  type: "text",
  inputMode: "numeric",
  pattern: "[0-9]{6}",
  maxLength: 6,
};

export const integerInputProps = {
  type: "text",
  inputMode: "numeric",
  pattern: "[0-9]*",
};

export const decimalInputProps = {
  type: "text",
  inputMode: "decimal",
  pattern: "[0-9]*[.]?[0-9]*",
};
